import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class ScrollerMobileVert extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      speciesName: this.props.speciesName,
      boatScores: this.props.boatScores,
      boatClass: this.props.boatClass,
      classBoats: [],
      tiles: this.props.tiles
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({boatScores: newProps.boatScores, rowWidth: newProps.rowWidth, tiles: newProps.tiles, boatClass: newProps.boatClass});
      this.classFilter();
  }
    
  classFilter() {
      var scores = this.props.boatScores;
      var boatClass = this.props.boatClass;
      var classBoats = [];
      scores.forEach((boat) => {
          if(boat.boat.boatClass === boatClass && boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              classBoats.push({
                  id: boat.boat.id,
                  boatClass: boat.boat.boatClass,
                  boatName: boat.boat.boatName,
									teamName: boat.boat.teamName,
                  boatThm: boat.boat.boatThm,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(classBoats);
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }
    
  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastSpeceiesFishTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })

    this.setState({
        classBoats: bScores
    })
  }
  
render() {
	
    if(this.state.boatScores.length > 0 && this.state.boatScores.length === 1 ){
      var numSlides = 1;
    } else if(this.state.boatScores.length === 2){
      var numSlides = 1;
    } else if(this.state.boatScores.length === 3){
      var numSlides = 2;
    } else if(this.state.boatScores.length === 4){
      var numSlides = 3;
    } else if(this.state.boatScores.length === 5){
      var numSlides = 4;
    } else {
      var numSlides = 5;
    } 
     const settings = {
			customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: false,
      slidesToShow: numSlides,
      slidesToScroll: numSlides,
      swipeToSlide: true,
			vertical: true,
    };
	
    return (
      <div className="smv-scoreContainer"> 
			<div className="score_box_title">Billfish Division</div>
          { this.state.boatScores.length > 0 ? this.state.boatScores.map(boat => (
            <div className="smv-boatBox" key={boat.boat.id}>
                {boat.boat.total > 0 ? <div id='boat-total' className="smv-logCellPhone">
									<div  className="smv-cellDetailsBox">
                    <div className="smv-rankBox1">
											# {boat.rank} {boat.boat.boatName}
										</div>
										<div id='rank' className="smv-rankBox2">
											Team: {boat.boat.teamName != boat.boat.boatName ? boat.boat.teamName: 'NA'}
										</div>
									</div>
									<div id='boat-total' className="smv-boat-total-box">
										{boat.boat.total} pts
									</div>
								</div>: null}
            </div>
          )) : <div className="smv-speciesName-phone" >No billfish logged yet.</div>
				}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/ptc/comps/ScrollerMobileVert.js